// removed by extract-text-webpack-plugin
module.exports = {"message":"localIdentName-message__message___1emf_","show":"localIdentName-message__show___Q2yjm","success":"localIdentName-message__success___2wAl0"};


//////////////////
// WEBPACK FOOTER
// ./css/components/message.css
// module id = 1428
// module chunks = 0